import script from "./Trade.vue?vue&type=script&setup=true&lang=js"
export * from "./Trade.vue?vue&type=script&setup=true&lang=js"

import "./Trade.vue?vue&type=style&index=0&id=79a4dc4e&lang=scss"

const __exports__ = script;

export default __exports__